import { usePracticeContext } from '../../../contexts';
import { useSheetPlayerBot } from './sheetPlayerBot';
export function useMetronomeBot() {
    const { practice, metronomeSheet, clock } = usePracticeContext();
    useSheetPlayerBot(metronomeSheet, practice.tempo, clock, 'standard_set');
}
//# sourceMappingURL=metronomeBot.js.map